export const DEFAULT_IMAGE = 'https://fan-guru-assets.s3.amazonaws.com/console/default-image.png';

// https://stackoverflow.com/a/54500197/1332403
const TIME_ZONES_LIST = [
  "Europe/Andorra",
  "Asia/Dubai",
  "Asia/Kabul",
  "Europe/Tirane",
  "Asia/Yerevan",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville", // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Antarctica/Mawson",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Cordoba",
  "America/Argentina/Salta",
  "America/Argentina/Jujuy",
  "America/Argentina/Tucuman",
  "America/Argentina/Catamarca",
  "America/Argentina/La_Rioja",
  "America/Argentina/San_Juan",
  "America/Argentina/Mendoza",
  "America/Argentina/San_Luis",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Ushuaia",
  "Pacific/Pago_Pago",
  "Europe/Vienna",
  "Australia/Lord_Howe",
  "Antarctica/Macquarie",
  "Australia/Hobart",
  "Australia/Currie",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Australia/Broken_Hill",
  "Australia/Brisbane",
  "Australia/Lindeman",
  "Australia/Adelaide",
  "Australia/Darwin",
  "Australia/Perth",
  "Australia/Eucla",
  "Asia/Baku",
  "America/Barbados",
  "Asia/Dhaka",
  "Europe/Brussels",
  "Europe/Sofia",
  "Atlantic/Bermuda",
  "Asia/Brunei",
  "America/La_Paz",
  "America/Noronha",
  "America/Belem",
  "America/Fortaleza",
  "America/Recife",
  "America/Araguaina",
  "America/Maceio",
  "America/Bahia",
  "America/Sao_Paulo",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Santarem",
  "America/Porto_Velho",
  "America/Boa_Vista",
  "America/Manaus",
  "America/Eirunepe",
  "America/Rio_Branco",
  "America/Nassau",
  "Asia/Thimphu",
  "Europe/Minsk",
  "America/Belize",
  "America/St_Johns",
  "America/Halifax",
  "America/Glace_Bay",
  "America/Moncton",
  "America/Goose_Bay",
  "America/Blanc-Sablon",
  "America/Toronto",
  "America/Nipigon",
  "America/Thunder_Bay",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Atikokan",
  "America/Winnipeg",
  "America/Rainy_River",
  "America/Resolute",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Swift_Current",
  "America/Edmonton",
  "America/Cambridge_Bay",
  "America/Yellowknife",
  "America/Inuvik",
  "America/Creston",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Dawson",
  "Indian/Cocos",
  "Europe/Zurich",
  "Africa/Abidjan",
  "Pacific/Rarotonga",
  "America/Santiago",
  "America/Punta_Arenas",
  "Pacific/Easter",
  "Asia/Shanghai",
  "Asia/Urumqi",
  "America/Bogota",
  "America/Costa_Rica",
  "America/Havana",
  "Atlantic/Cape_Verde",
  "America/Curacao",
  "Indian/Christmas",
  "Asia/Nicosia",
  "Asia/Famagusta",
  "Europe/Prague",
  "Europe/Berlin",
  "Europe/Copenhagen",
  "America/Santo_Domingo",
  "Africa/Algiers",
  "America/Guayaquil",
  "Pacific/Galapagos",
  "Europe/Tallinn",
  "Africa/Cairo",
  "Africa/El_Aaiun",
  "Europe/Madrid",
  "Africa/Ceuta",
  "Atlantic/Canary",
  "Europe/Helsinki",
  "Pacific/Fiji",
  "Atlantic/Stanley",
  "Pacific/Chuuk",
  "Pacific/Pohnpei",
  "Pacific/Kosrae",
  "Atlantic/Faroe",
  "Europe/Paris",
  "Europe/London",
  "Asia/Tbilisi",
  "America/Cayenne",
  "Africa/Accra",
  "Europe/Gibraltar",
  "America/Godthab",
  "America/Danmarkshavn",
  "America/Scoresbysund",
  "America/Thule",
  "Europe/Athens",
  "Atlantic/South_Georgia",
  "America/Guatemala",
  "Pacific/Guam",
  "Africa/Bissau",
  "America/Guyana",
  "Asia/Hong_Kong",
  "America/Tegucigalpa",
  "America/Port-au-Prince",
  "Europe/Budapest",
  "Asia/Jakarta",
  "Asia/Pontianak",
  "Asia/Makassar",
  "Asia/Jayapura",
  "Europe/Dublin",
  "Asia/Jerusalem",
  "Asia/Kolkata",
  "Indian/Chagos",
  "Asia/Baghdad",
  "Asia/Tehran",
  "Atlantic/Reykjavik",
  "Europe/Rome",
  "America/Jamaica",
  "Asia/Amman",
  "Asia/Tokyo",
  "Africa/Nairobi",
  "Asia/Bishkek",
  "Pacific/Tarawa",
  "Pacific/Enderbury",
  "Pacific/Kiritimati",
  "Asia/Pyongyang",
  "Asia/Seoul",
  "Asia/Almaty",
  "Asia/Qyzylorda",
  "Asia/Qostanay", // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Asia/Aqtobe",
  "Asia/Aqtau",
  "Asia/Atyrau",
  "Asia/Oral",
  "Asia/Beirut",
  "Asia/Colombo",
  "Africa/Monrovia",
  "Europe/Vilnius",
  "Europe/Luxembourg",
  "Europe/Riga",
  "Africa/Tripoli",
  "Africa/Casablanca",
  "Europe/Monaco",
  "Europe/Chisinau",
  "Pacific/Majuro",
  "Pacific/Kwajalein",
  "Asia/Yangon",
  "Asia/Ulaanbaatar",
  "Asia/Hovd",
  "Asia/Choibalsan",
  "Asia/Macau",
  "America/Martinique",
  "Europe/Malta",
  "Indian/Mauritius",
  "Indian/Maldives",
  "America/Mexico_City",
  "America/Cancun",
  "America/Merida",
  "America/Monterrey",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Chihuahua",
  "America/Ojinaga",
  "America/Hermosillo",
  "America/Tijuana",
  "America/Bahia_Banderas",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Africa/Maputo",
  "Africa/Windhoek",
  "Pacific/Noumea",
  "Pacific/Norfolk",
  "Africa/Lagos",
  "America/Managua",
  "Europe/Amsterdam",
  "Europe/Oslo",
  "Asia/Kathmandu",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Auckland",
  "Pacific/Chatham",
  "America/Panama",
  "America/Lima",
  "Pacific/Tahiti",
  "Pacific/Marquesas",
  "Pacific/Gambier",
  "Pacific/Port_Moresby",
  "Pacific/Bougainville",
  "Asia/Manila",
  "Asia/Karachi",
  "Europe/Warsaw",
  "America/Miquelon",
  "Pacific/Pitcairn",
  "America/Puerto_Rico",
  "Asia/Gaza",
  "Asia/Hebron",
  "Europe/Lisbon",
  "Atlantic/Madeira",
  "Atlantic/Azores",
  "Pacific/Palau",
  "America/Asuncion",
  "Asia/Qatar",
  "Indian/Reunion",
  "Europe/Bucharest",
  "Europe/Belgrade",
  "Europe/Kaliningrad",
  "Europe/Moscow",
  "Europe/Simferopol",
  "Europe/Kirov",
  "Europe/Astrakhan",
  "Europe/Volgograd",
  "Europe/Saratov",
  "Europe/Ulyanovsk",
  "Europe/Samara",
  "Asia/Yekaterinburg",
  "Asia/Omsk",
  "Asia/Novosibirsk",
  "Asia/Barnaul",
  "Asia/Tomsk",
  "Asia/Novokuznetsk",
  "Asia/Krasnoyarsk",
  "Asia/Irkutsk",
  "Asia/Chita",
  "Asia/Yakutsk",
  "Asia/Khandyga",
  "Asia/Vladivostok",
  "Asia/Ust-Nera",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Asia/Srednekolymsk",
  "Asia/Kamchatka",
  "Asia/Anadyr",
  "Asia/Riyadh",
  "Pacific/Guadalcanal",
  "Indian/Mahe",
  "Africa/Khartoum",
  "Europe/Stockholm",
  "Asia/Singapore",
  "America/Paramaribo",
  "Africa/Juba",
  "Africa/Sao_Tome",
  "America/El_Salvador",
  "Asia/Damascus",
  "America/Grand_Turk",
  "Africa/Ndjamena",
  "Indian/Kerguelen",
  "Asia/Bangkok",
  "Asia/Dushanbe",
  "Pacific/Fakaofo",
  "Asia/Dili",
  "Asia/Ashgabat",
  "Africa/Tunis",
  "Pacific/Tongatapu",
  "Europe/Istanbul",
  "America/Port_of_Spain",
  "Pacific/Funafuti",
  "Asia/Taipei",
  "Europe/Kiev",
  "Europe/Uzhgorod",
  "Europe/Zaporozhye",
  "Pacific/Wake",
  "America/New_York",
  "America/Detroit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Indiana/Indianapolis",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Chicago",
  "America/Indiana/Tell_City",
  "America/Indiana/Knox",
  "America/Menominee",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/North_Dakota/Beulah",
  "America/Denver",
  "America/Boise",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Juneau",
  "America/Sitka",
  "America/Metlakatla",
  "America/Yakutat",
  "America/Nome",
  "America/Adak",
  "Pacific/Honolulu",
  "America/Montevideo",
  "Asia/Samarkand",
  "Asia/Tashkent",
  "America/Caracas",
  "Asia/Ho_Chi_Minh",
  "Pacific/Efate",
  "Pacific/Wallis",
  "Pacific/Apia",
  "Africa/Johannesburg",
].sort()

/**
 * Well-known timezone abbreviations keyed by IANA timezone ID.
 * Used as fallback when Intl.DateTimeFormat returns a generic GMT offset
 * instead of a named abbreviation (common on Windows Chrome).
 * Format: [standardAbbr] or [standardAbbr, daylightAbbr]
 */
const TIMEZONE_ABBR_OVERRIDES: Record<string, [string] | [string, string]> = {
  // ── Americas ──────────────────────────────────────────────
  // US Eastern
  "America/New_York": ["EST", "EDT"],
  "America/Detroit": ["EST", "EDT"],
  "America/Kentucky/Louisville": ["EST", "EDT"],
  "America/Kentucky/Monticello": ["EST", "EDT"],
  "America/Indiana/Indianapolis": ["EST", "EDT"],
  "America/Indiana/Vincennes": ["EST", "EDT"],
  "America/Indiana/Winamac": ["EST", "EDT"],
  "America/Indiana/Marengo": ["EST", "EDT"],
  "America/Indiana/Petersburg": ["EST", "EDT"],
  "America/Indiana/Vevay": ["EST", "EDT"],
  // US Central
  "America/Chicago": ["CST", "CDT"],
  "America/Indiana/Tell_City": ["CST", "CDT"],
  "America/Indiana/Knox": ["CST", "CDT"],
  "America/Menominee": ["CST", "CDT"],
  "America/North_Dakota/Center": ["CST", "CDT"],
  "America/North_Dakota/New_Salem": ["CST", "CDT"],
  "America/North_Dakota/Beulah": ["CST", "CDT"],
  // US Mountain
  "America/Denver": ["MST", "MDT"],
  "America/Boise": ["MST", "MDT"],
  "America/Phoenix": ["MST"],
  // US Pacific
  "America/Los_Angeles": ["PST", "PDT"],
  // US Alaska
  "America/Anchorage": ["AKST", "AKDT"],
  "America/Juneau": ["AKST", "AKDT"],
  "America/Sitka": ["AKST", "AKDT"],
  "America/Metlakatla": ["AKST", "AKDT"],
  "America/Yakutat": ["AKST", "AKDT"],
  "America/Nome": ["AKST", "AKDT"],
  "America/Adak": ["HST", "HDT"],
  // US Hawaii
  "Pacific/Honolulu": ["HST"],
  // Canada
  "America/St_Johns": ["NST", "NDT"],
  "America/Halifax": ["AST", "ADT"],
  "America/Glace_Bay": ["AST", "ADT"],
  "America/Moncton": ["AST", "ADT"],
  "America/Goose_Bay": ["AST", "ADT"],
  "America/Toronto": ["EST", "EDT"],
  "America/Nipigon": ["EST", "EDT"],
  "America/Thunder_Bay": ["EST", "EDT"],
  "America/Iqaluit": ["EST", "EDT"],
  "America/Pangnirtung": ["EST", "EDT"],
  "America/Winnipeg": ["CST", "CDT"],
  "America/Rainy_River": ["CST", "CDT"],
  "America/Resolute": ["CST", "CDT"],
  "America/Rankin_Inlet": ["CST", "CDT"],
  "America/Regina": ["CST"],
  "America/Swift_Current": ["CST"],
  "America/Edmonton": ["MST", "MDT"],
  "America/Cambridge_Bay": ["MST", "MDT"],
  "America/Yellowknife": ["MST", "MDT"],
  "America/Inuvik": ["MST", "MDT"],
  "America/Vancouver": ["PST", "PDT"],
  "America/Dawson_Creek": ["MST"],
  "America/Fort_Nelson": ["MST"],
  "America/Whitehorse": ["MST"],
  "America/Dawson": ["MST"],
  "America/Creston": ["MST"],
  "America/Atikokan": ["EST"],
  "America/Blanc-Sablon": ["AST"],
  // Mexico
  "America/Mexico_City": ["CST", "CDT"],
  "America/Cancun": ["EST"],
  "America/Merida": ["CST", "CDT"],
  "America/Monterrey": ["CST", "CDT"],
  "America/Matamoros": ["CST", "CDT"],
  "America/Mazatlan": ["MST", "MDT"],
  "America/Chihuahua": ["MST", "MDT"],
  "America/Ojinaga": ["CST", "CDT"],
  "America/Hermosillo": ["MST"],
  "America/Tijuana": ["PST", "PDT"],
  "America/Bahia_Banderas": ["CST", "CDT"],
  // Caribbean & Central America
  "America/Nassau": ["EST", "EDT"],
  "America/Jamaica": ["EST"],
  "America/Havana": ["CST", "CDT"],
  "America/Port-au-Prince": ["EST", "EDT"],
  "America/Grand_Turk": ["EST", "EDT"],
  "America/Barbados": ["AST"],
  "America/Martinique": ["AST"],
  "America/Curacao": ["AST"],
  "America/Port_of_Spain": ["AST"],
  "America/Santo_Domingo": ["AST"],
  "America/Puerto_Rico": ["AST"],
  "Atlantic/Bermuda": ["AST", "ADT"],
  "America/Panama": ["EST"],
  "America/Costa_Rica": ["CST"],
  "America/Guatemala": ["CST"],
  "America/El_Salvador": ["CST"],
  "America/Managua": ["CST"],
  "America/Tegucigalpa": ["CST"],
  "America/Belize": ["CST"],
  "America/Guyana": ["GYT"],
  "America/Cayenne": ["GFT"],
  "America/Paramaribo": ["SRT"],
  // South America
  "America/Bogota": ["COT"],
  "America/Lima": ["PET"],
  "America/Guayaquil": ["ECT"],
  "America/La_Paz": ["BOT"],
  "America/Caracas": ["VET"],
  "America/Santiago": ["CLT", "CLST"],
  "America/Punta_Arenas": ["CLT"],
  "America/Asuncion": ["PYT", "PYST"],
  "America/Montevideo": ["UYT"],
  "America/Argentina/Buenos_Aires": ["ART"],
  "America/Argentina/Cordoba": ["ART"],
  "America/Argentina/Salta": ["ART"],
  "America/Argentina/Jujuy": ["ART"],
  "America/Argentina/Tucuman": ["ART"],
  "America/Argentina/Catamarca": ["ART"],
  "America/Argentina/La_Rioja": ["ART"],
  "America/Argentina/San_Juan": ["ART"],
  "America/Argentina/Mendoza": ["ART"],
  "America/Argentina/San_Luis": ["ART"],
  "America/Argentina/Rio_Gallegos": ["ART"],
  "America/Argentina/Ushuaia": ["ART"],
  // Brazil
  "America/Sao_Paulo": ["BRT"],
  "America/Noronha": ["FNT"],
  "America/Belem": ["BRT"],
  "America/Fortaleza": ["BRT"],
  "America/Recife": ["BRT"],
  "America/Araguaina": ["BRT"],
  "America/Maceio": ["BRT"],
  "America/Bahia": ["BRT"],
  "America/Santarem": ["BRT"],
  "America/Manaus": ["AMT"],
  "America/Boa_Vista": ["AMT"],
  "America/Porto_Velho": ["AMT"],
  "America/Campo_Grande": ["AMT"],
  "America/Cuiaba": ["AMT"],
  "America/Eirunepe": ["ACT"],
  "America/Rio_Branco": ["ACT"],
  // Greenland
  "America/Godthab": ["WGT", "WGST"],
  "America/Danmarkshavn": ["GMT"],
  "America/Scoresbysund": ["EGT", "EGST"],
  "America/Thule": ["AST", "ADT"],
  // Other Americas
  "America/Miquelon": ["PMST", "PMDT"],
  "Atlantic/Stanley": ["FKST"],
  "Atlantic/South_Georgia": ["GST"],

  // ── Europe ────────────────────────────────────────────────
  "Europe/London": ["GMT", "BST"],
  "Europe/Dublin": ["GMT", "IST"],
  "Europe/Lisbon": ["WET", "WEST"],
  "Atlantic/Madeira": ["WET", "WEST"],
  "Atlantic/Canary": ["WET", "WEST"],
  "Atlantic/Faroe": ["WET", "WEST"],
  "Atlantic/Reykjavik": ["GMT"],
  "Europe/Paris": ["CET", "CEST"],
  "Europe/Berlin": ["CET", "CEST"],
  "Europe/Rome": ["CET", "CEST"],
  "Europe/Madrid": ["CET", "CEST"],
  "Europe/Brussels": ["CET", "CEST"],
  "Europe/Amsterdam": ["CET", "CEST"],
  "Europe/Luxembourg": ["CET", "CEST"],
  "Europe/Monaco": ["CET", "CEST"],
  "Europe/Zurich": ["CET", "CEST"],
  "Europe/Vienna": ["CET", "CEST"],
  "Europe/Prague": ["CET", "CEST"],
  "Europe/Warsaw": ["CET", "CEST"],
  "Europe/Budapest": ["CET", "CEST"],
  "Europe/Belgrade": ["CET", "CEST"],
  "Europe/Malta": ["CET", "CEST"],
  "Europe/Copenhagen": ["CET", "CEST"],
  "Europe/Oslo": ["CET", "CEST"],
  "Europe/Stockholm": ["CET", "CEST"],
  "Europe/Andorra": ["CET", "CEST"],
  "Europe/Gibraltar": ["CET", "CEST"],
  "Europe/Tirane": ["CET", "CEST"],
  "Europe/Athens": ["EET", "EEST"],
  "Europe/Bucharest": ["EET", "EEST"],
  "Europe/Sofia": ["EET", "EEST"],
  "Europe/Helsinki": ["EET", "EEST"],
  "Europe/Tallinn": ["EET", "EEST"],
  "Europe/Vilnius": ["EET", "EEST"],
  "Europe/Riga": ["EET", "EEST"],
  "Europe/Kiev": ["EET", "EEST"],
  "Europe/Uzhgorod": ["EET", "EEST"],
  "Europe/Zaporozhye": ["EET", "EEST"],
  "Europe/Chisinau": ["EET", "EEST"],
  "Europe/Istanbul": ["TRT"],
  "Europe/Minsk": ["MSK"],
  "Europe/Moscow": ["MSK"],
  "Europe/Simferopol": ["MSK"],
  "Europe/Kirov": ["MSK"],
  "Europe/Kaliningrad": ["EET"],
  "Europe/Astrakhan": ["MSK+1"],
  "Europe/Volgograd": ["MSK"],
  "Europe/Saratov": ["MSK+1"],
  "Europe/Ulyanovsk": ["MSK+1"],
  "Europe/Samara": ["SAMT"],

  // ── Africa ────────────────────────────────────────────────
  "Africa/Cairo": ["EET", "EEST"],
  "Africa/Tripoli": ["EET"],
  "Africa/Algiers": ["CET"],
  "Africa/Tunis": ["CET"],
  "Africa/Ceuta": ["CET", "CEST"],
  "Africa/Casablanca": ["WET", "WEST"],
  "Africa/El_Aaiun": ["WET", "WEST"],
  "Africa/Lagos": ["WAT"],
  "Africa/Ndjamena": ["WAT"],
  "Africa/Windhoek": ["CAT"],
  "Africa/Maputo": ["CAT"],
  "Africa/Johannesburg": ["SAST"],
  "Africa/Khartoum": ["CAT"],
  "Africa/Juba": ["CAT"],
  "Africa/Nairobi": ["EAT"],
  "Africa/Abidjan": ["GMT"],
  "Africa/Accra": ["GMT"],
  "Africa/Monrovia": ["GMT"],
  "Africa/Bissau": ["GMT"],
  "Africa/Sao_Tome": ["GMT"],

  // ── Asia ──────────────────────────────────────────────────
  // South Asia
  "Asia/Kolkata": ["IST"],
  "Asia/Colombo": ["IST"],
  "Asia/Karachi": ["PKT"],
  "Asia/Dhaka": ["BST"],
  "Asia/Kathmandu": ["NPT"],
  "Asia/Thimphu": ["BTT"],
  // Southeast Asia
  "Asia/Bangkok": ["ICT"],
  "Asia/Ho_Chi_Minh": ["ICT"],
  "Asia/Jakarta": ["WIB"],
  "Asia/Pontianak": ["WIB"],
  "Asia/Makassar": ["WITA"],
  "Asia/Jayapura": ["WIT"],
  "Asia/Manila": ["PHT"],
  "Asia/Kuala_Lumpur": ["MYT"],
  "Asia/Kuching": ["MYT"],
  "Asia/Singapore": ["SGT"],
  "Asia/Brunei": ["BNT"],
  "Asia/Yangon": ["MMT"],
  "Asia/Dili": ["TLT"],
  // East Asia
  "Asia/Shanghai": ["CST"],
  "Asia/Urumqi": ["CST"],
  "Asia/Macau": ["CST"],
  "Asia/Taipei": ["CST"],
  "Asia/Hong_Kong": ["HKT"],
  "Asia/Tokyo": ["JST"],
  "Asia/Seoul": ["KST"],
  "Asia/Pyongyang": ["KST"],
  // Central Asia
  "Asia/Almaty": ["ALMT"],
  "Asia/Qyzylorda": ["QYZT"],
  "Asia/Qostanay": ["QOST"],
  "Asia/Aqtobe": ["AQTT"],
  "Asia/Aqtau": ["AQTT"],
  "Asia/Atyrau": ["AQTT"],
  "Asia/Oral": ["ORAT"],
  "Asia/Bishkek": ["KGT"],
  "Asia/Tashkent": ["UZT"],
  "Asia/Samarkand": ["UZT"],
  "Asia/Dushanbe": ["TJT"],
  "Asia/Ashgabat": ["TMT"],
  // West Asia / Middle East
  "Asia/Dubai": ["GST"],
  "Asia/Riyadh": ["AST"],
  "Asia/Qatar": ["AST"],
  "Asia/Baghdad": ["AST"],
  "Asia/Tehran": ["IRST", "IRDT"],
  "Asia/Kabul": ["AFT"],
  "Asia/Yerevan": ["AMT"],
  "Asia/Tbilisi": ["GET"],
  "Asia/Baku": ["AZT"],
  "Asia/Jerusalem": ["IST", "IDT"],
  "Asia/Beirut": ["EET", "EEST"],
  "Asia/Damascus": ["EET", "EEST"],
  "Asia/Amman": ["EET", "EEST"],
  "Asia/Gaza": ["EET", "EEST"],
  "Asia/Hebron": ["EET", "EEST"],
  "Asia/Nicosia": ["EET", "EEST"],
  "Asia/Famagusta": ["EET", "EEST"],
  // Russia (Asian part)
  "Asia/Yekaterinburg": ["YEKT"],
  "Asia/Omsk": ["OMST"],
  "Asia/Novosibirsk": ["NOVT"],
  "Asia/Barnaul": ["NOVT"],
  "Asia/Tomsk": ["NOVT"],
  "Asia/Novokuznetsk": ["KRAT"],
  "Asia/Krasnoyarsk": ["KRAT"],
  "Asia/Irkutsk": ["IRKT"],
  "Asia/Chita": ["YAKT"],
  "Asia/Yakutsk": ["YAKT"],
  "Asia/Khandyga": ["YAKT"],
  "Asia/Vladivostok": ["VLAT"],
  "Asia/Ust-Nera": ["VLAT"],
  "Asia/Magadan": ["MAGT"],
  "Asia/Sakhalin": ["SAKT"],
  "Asia/Srednekolymsk": ["SRET"],
  "Asia/Kamchatka": ["PETT"],
  "Asia/Anadyr": ["ANAT"],
  // Mongolia
  "Asia/Ulaanbaatar": ["ULAT"],
  "Asia/Hovd": ["HOVT"],
  "Asia/Choibalsan": ["CHOT"],

  // ── Indian Ocean ──────────────────────────────────────────
  "Indian/Maldives": ["MVT"],
  "Indian/Mauritius": ["MUT"],
  "Indian/Reunion": ["RET"],
  "Indian/Mahe": ["SCT"],
  "Indian/Chagos": ["IOT"],
  "Indian/Cocos": ["CCT"],
  "Indian/Christmas": ["CXT"],
  "Indian/Kerguelen": ["TFT"],

  // ── Australia ─────────────────────────────────────────────
  "Australia/Lord_Howe": ["LHST", "LHDT"],
  "Australia/Hobart": ["AEST", "AEDT"],
  "Australia/Currie": ["AEST", "AEDT"],
  "Australia/Melbourne": ["AEST", "AEDT"],
  "Australia/Sydney": ["AEST", "AEDT"],
  "Australia/Brisbane": ["AEST"],
  "Australia/Lindeman": ["AEST"],
  "Australia/Adelaide": ["ACST", "ACDT"],
  "Australia/Broken_Hill": ["ACST", "ACDT"],
  "Australia/Darwin": ["ACST"],
  "Australia/Perth": ["AWST"],
  "Australia/Eucla": ["ACWST"],
  "Antarctica/Macquarie": ["AEST", "AEDT"],

  // ── Pacific ───────────────────────────────────────────────
  "Pacific/Auckland": ["NZST", "NZDT"],
  "Pacific/Chatham": ["CHAST", "CHADT"],
  "Pacific/Fiji": ["FJT"],
  "Pacific/Tongatapu": ["TOT"],
  "Pacific/Apia": ["WST"],
  "Pacific/Pago_Pago": ["SST"],
  "Pacific/Guam": ["ChST"],
  "Pacific/Noumea": ["NCT"],
  "Pacific/Norfolk": ["NFT"],
  "Pacific/Tarawa": ["GILT"],
  "Pacific/Enderbury": ["PHOT"],
  "Pacific/Kiritimati": ["LINT"],
  "Pacific/Nauru": ["NRT"],
  "Pacific/Funafuti": ["TVT"],
  "Pacific/Wallis": ["WFT"],
  "Pacific/Fakaofo": ["TKT"],
  "Pacific/Majuro": ["MHT"],
  "Pacific/Kwajalein": ["MHT"],
  "Pacific/Palau": ["PWT"],
  "Pacific/Chuuk": ["CHUT"],
  "Pacific/Pohnpei": ["PONT"],
  "Pacific/Kosrae": ["KOST"],
  "Pacific/Port_Moresby": ["PGT"],
  "Pacific/Bougainville": ["BST"],
  "Pacific/Efate": ["VUT"],
  "Pacific/Guadalcanal": ["SBT"],
  "Pacific/Tahiti": ["TAHT"],
  "Pacific/Marquesas": ["MART"],
  "Pacific/Gambier": ["GAMT"],
  "Pacific/Pitcairn": ["PST"],
  "Pacific/Rarotonga": ["CKT"],
  "Pacific/Niue": ["NUT"],
  "Pacific/Wake": ["WAKT"],
  "Pacific/Easter": ["EAST", "EASST"],
  "Pacific/Galapagos": ["GALT"],

  // ── Antarctica ────────────────────────────────────────────
  "Antarctica/Casey": ["CAST"],
  "Antarctica/Davis": ["DAVT"],
  "Antarctica/DumontDUrville": ["DDUT"],
  "Antarctica/Mawson": ["MAWT"],
  "Antarctica/Palmer": ["CLT", "CLST"],
  "Antarctica/Rothera": ["ROTT"],
  "Antarctica/Syowa": ["SYOT"],
  "Antarctica/Troll": ["CET", "CEST"],
  "Antarctica/Vostok": ["VOST"],

  // ── Atlantic ──────────────────────────────────────────────
  "Atlantic/Cape_Verde": ["CVT"],
  "Atlantic/Azores": ["AZOT", "AZOST"],
}

/**
 * Map of timezone abbreviations that are genuinely ambiguous — the same
 * abbreviation is used by timezones with DIFFERENT UTC offsets.
 * Only these require region disambiguation in the display name.
 */
const AMBIGUOUS_ABBREVIATIONS: Record<string, Record<string, string>> = {
  IST: {
    // UTC+5:30 (India) vs UTC+2/+3 (Israel) vs UTC+0/+1 (Ireland)
    "Asia/Kolkata": "India",
    "Asia/Colombo": "Sri Lanka",
    "Asia/Jerusalem": "Israel",
    "Europe/Dublin": "Ireland",
  },
  CST: {
    // UTC-6 (US/Mexico/Central America) vs UTC+8 (China) vs UTC-5 (Cuba)
    "America/Chicago": "US",
    "America/Indiana/Tell_City": "US",
    "America/Indiana/Knox": "US",
    "America/Menominee": "US",
    "America/North_Dakota/Center": "US",
    "America/North_Dakota/New_Salem": "US",
    "America/North_Dakota/Beulah": "US",
    "America/Matamoros": "US",
    "America/Winnipeg": "Canada",
    "America/Rainy_River": "Canada",
    "America/Rankin_Inlet": "Canada",
    "America/Resolute": "Canada",
    "America/Regina": "Canada",
    "America/Swift_Current": "Canada",
    "America/Mexico_City": "Mexico",
    "America/Merida": "Mexico",
    "America/Monterrey": "Mexico",
    "America/Bahia_Banderas": "Mexico",
    "America/Costa_Rica": "Central America",
    "America/Guatemala": "Central America",
    "America/El_Salvador": "Central America",
    "America/Managua": "Central America",
    "America/Tegucigalpa": "Central America",
    "America/Belize": "Central America",
    "Asia/Shanghai": "China",
    "Asia/Urumqi": "China",
    "Asia/Macau": "China",
    "Asia/Taipei": "China",
    "America/Havana": "Cuba",
  },
  CDT: {
    // UTC-5 (US/Mexico) vs UTC-4 (Cuba)
    "America/Chicago": "US",
    "America/Indiana/Tell_City": "US",
    "America/Indiana/Knox": "US",
    "America/Menominee": "US",
    "America/North_Dakota/Center": "US",
    "America/North_Dakota/New_Salem": "US",
    "America/North_Dakota/Beulah": "US",
    "America/Matamoros": "US",
    "America/Winnipeg": "Canada",
    "America/Rainy_River": "Canada",
    "America/Rankin_Inlet": "Canada",
    "America/Resolute": "Canada",
    "America/Mexico_City": "Mexico",
    "America/Merida": "Mexico",
    "America/Monterrey": "Mexico",
    "America/Bahia_Banderas": "Mexico",
    "America/Ojinaga": "Mexico",
    "America/Havana": "Cuba",
  },
  BST: {
    // UTC+1 (UK summer) vs UTC+6 (Bangladesh)
    "Europe/London": "UK",
    "Asia/Dhaka": "Bangladesh",
    "Pacific/Bougainville": "Bougainville",
  },
  GST: {
    // UTC+4 (Gulf) vs UTC-2 (South Georgia)
    "Asia/Dubai": "Gulf",
    "Atlantic/South_Georgia": "South Georgia",
  },
  AMT: {
    // UTC-4 (Amazon/Brazil) vs UTC+4 (Armenia)
    "America/Manaus": "Brazil",
    "America/Boa_Vista": "Brazil",
    "America/Porto_Velho": "Brazil",
    "America/Campo_Grande": "Brazil",
    "America/Cuiaba": "Brazil",
    "Asia/Yerevan": "Armenia",
  },
  AST: {
    // UTC-4 (Atlantic) vs UTC+3 (Arabia)
    "America/Puerto_Rico": "Atlantic",
    "America/Halifax": "Atlantic",
    "America/Glace_Bay": "Atlantic",
    "America/Moncton": "Atlantic",
    "America/Goose_Bay": "Atlantic",
    "America/Barbados": "Atlantic",
    "America/Martinique": "Atlantic",
    "America/Curacao": "Atlantic",
    "America/Port_of_Spain": "Atlantic",
    "America/Santo_Domingo": "Atlantic",
    "Atlantic/Bermuda": "Atlantic",
    "America/Thule": "Atlantic",
    "Asia/Baghdad": "Arabia",
    "Asia/Riyadh": "Arabia",
    "Asia/Qatar": "Arabia",
  },
  PST: {
    // UTC-8 (Pacific/US) vs UTC-8 (Pitcairn)
    "America/Los_Angeles": "US",
    "America/Vancouver": "Canada",
    "America/Tijuana": "Mexico",
    "Pacific/Pitcairn": "Pitcairn",
  },
}

/**
 * Detects whether Daylight Saving Time is currently active for a timezone.
 * Compares the UTC offset in January vs July; if they differ, DST is observed,
 * and the current offset is compared to determine which mode is active.
 */
function isDSTActive(tzId: string): boolean {
  try {
    const year = new Date().getFullYear()
    const jan = new Date(Date.UTC(year, 0, 1, 12))
    const jul = new Date(Date.UTC(year, 6, 1, 12))
    const now = new Date()

    const getOffset = (date: Date): number => {
      const utcStr = date.toLocaleString("en-US", { timeZone: "UTC" })
      const tzStr = date.toLocaleString("en-US", { timeZone: tzId })
      return new Date(tzStr).getTime() - new Date(utcStr).getTime()
    }

    const janOffset = getOffset(jan)
    const julOffset = getOffset(jul)

    if (janOffset === julOffset) return false // No DST observed

    const nowOffset = getOffset(now)
    // DST moves clocks forward → larger (more positive) offset
    const dstOffset = Math.max(janOffset, julOffset)
    return nowOffset === dstOffset
  } catch {
    return false
  }
}

/**
 * Extracts the timezone abbreviation for a given IANA timezone ID.
 * 1. Tries Intl.DateTimeFormat first — if it returns a named abbreviation, uses it.
 * 2. If Intl returns a GMT offset (e.g. "GMT+5:30"), falls back to
 *    the TIMEZONE_ABBR_OVERRIDES map with DST detection.
 * 3. If no override is found, returns the GMT offset.
 */
function getTimezoneAbbreviation(tzId: string): string {
  try {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tzId,
      timeZoneName: "short",
    })
    const parts = formatter.formatToParts(new Date())
    const intlAbbr = parts.find((p) => p.type === "timeZoneName")?.value ?? ""

    // If Intl returned a named abbreviation (not a GMT/UTC offset), use it directly
    if (intlAbbr && !/^(GMT|UTC)([+-]|$)/.test(intlAbbr)) {
      return intlAbbr
    }

    // Intl returned a GMT offset — check the override map
    const override = TIMEZONE_ABBR_OVERRIDES[tzId]
    if (override) {
      if (override.length === 1) return override[0]
      // Has DST variant — pick the right one
      return isDSTActive(tzId) ? override[1] : override[0]
    }

    // No override found — use the GMT offset from Intl
    return intlAbbr
  } catch {
    return ""
  }
}

/**
 * Returns a display-friendly timezone name with abbreviation.
 * Examples:
 *   "America/New_York"  → "America/New York (EST)"
 *   "Asia/Kolkata"      → "Asia/Kolkata (IST - India)"
 *   "Asia/Jerusalem"    → "Asia/Jerusalem (IST - Israel)"
 *   "Indian/Chagos"     → "Indian/Chagos (GMT+6)" (no named abbreviation)
 */
export function getTimezoneDisplayName(tzId: string): string {
  const readableName = tzId.replace(/_/g, " ")
  const abbr = getTimezoneAbbreviation(tzId)

  if (!abbr) return readableName

  // Check if this abbreviation is ambiguous
  const disambiguationMap = AMBIGUOUS_ABBREVIATIONS[abbr]
  if (disambiguationMap && disambiguationMap[tzId]) {
    return `${readableName} (${abbr} - ${disambiguationMap[tzId]})`
  }

  return `${readableName} (${abbr})`
}

/**
 * Pre-computed timezone items for use in search/select lists.
 * Each item has:
 *  - id: the raw IANA timezone ID (used as the value)
 *  - name: the display-friendly name with abbreviation (used for display and search)
 */
export const TIME_ZONES = TIME_ZONES_LIST.map((tz) => ({
  value: tz,
  label: getTimezoneDisplayName(tz),
}))
